import { nextTick } from 'vue'

const ellipsisTooltip = {
  bind(el, binding) {
    // 设置行数，默认为1行
    const lineClamp = Number(binding.value) || 1
    el.classList.add('zu-line-clamp')
    el.style.webkitLineClamp = lineClamp

    // 创建tooltip元素
    let tooltip = document.createElement('div')
    tooltip.className = 'zu-tooltip'
    tooltip.style.display = 'none'

    // 创建箭头元素
    const arrow = document.createElement('div')
    arrow.className = 'zu-tooltip-arrow zu-tooltip-arrow-top'

    tooltip.innerHTML = el.textContent + arrow.outerHTML
    tooltip.appendChild(arrow)

    nextTick(() => {
      // 检查是否文本溢出
      // 如果文本没有溢出，则不需要tooltip
      if (el.scrollHeight <= el.offsetHeight) {
        tooltip = null
        return
      }
      document.body.appendChild(tooltip)
      // 存储tooltip引用
      el._tooltip = tooltip
      // 鼠标进入事件
      el.addEventListener('mouseenter', function(e) {
        tooltip.style.display = 'block'
        // 定位tooltip
        const rect = el.getBoundingClientRect()
        const tooltipRect = tooltip.getBoundingClientRect()

        let top = rect.top - tooltipRect.height - 8
        let left = rect.left + (rect.width - tooltipRect.width) / 2

        // 防止tooltip超出屏幕
        if (top < 5) top = rect.bottom + 8
        if (left < 5) left = 5
        if (left + tooltipRect.width > window.innerWidth - 5) {
          left = window.innerWidth - tooltipRect.width - 5
        }
        tooltip.style.top = top + window.scrollY + 'px'
        tooltip.style.left = left + window.scrollX + 'px'
      });
      // 鼠标离开事件
      el.addEventListener('mouseleave', function() {
        tooltip.style.display = 'none'
      })
    })
  },

  unbind(el) {
    // 清理工作
    if (el._tooltip) {
      document.body.removeChild(el._tooltip)
      delete el._tooltip
    }
  }
}
export default ellipsisTooltip
